import { ICompany, IStore, IUserProfile, IPrivacyStatement, IPomReportCategoryData, ISettings, IMailTemplateDetails, IInfoTextDetails } from './DataModelInterface';

export const storeValue = (key: string, value: string | null) => {
  if (value !== null) {
    sessionStorage.setItem(key, value);
  } else {
    clearValue(key);
  }
}

export const clearStore = () => {
  sessionStorage.removeItem('store');
}

export const storeObject = (key: string, value: object) => {
  const valueStr = JSON.stringify(value);
  storeValue(key, valueStr);
}

export const fetchValue = (key: string) => {
  return sessionStorage.getItem(key);
}

export const fetchObject = (key: string) => {
  const value = fetchValue(key);
  return value ? JSON.parse(value) : null;
}

export const clearValue = (key: string) => {
  sessionStorage.removeItem(key);
}

const getStore = () => {
  const store: IStore = fetchObject('store') || {};
  return store;
}

export const getBackendVersion = () => {
  const store = getStore();
  return store ? store.backendversion : "";
}

export const setBackendVersion = (version: string) => {
  const store = getStore();
  store.backendversion = version;
  storeObject('store', store);
}


export const getServerTime = () => {
  const store = getStore();
  return store ? store.serverTime : "";
}

export const setServerTime = (time: string) => {
  const store = getStore();
  store.serverTime = time;
  storeObject('store', store);
}

export function setUser(user: IUserProfile) {
  const store = getStore();
  store.user = user;
  storeObject('store', store);
}

export const getUser = () => {
  const store = getStore();
  return store ? store.user : {} as IUserProfile;
}

export function setUsers(users: IUserProfile[]) {
  const store = getStore();
  store.users = users;
  storeObject('store', store);
}

export const getUsers = () => {
  const store = getStore();
  return store ? store.users : [] as IUserProfile[];
}

export function setCompanies(companies: ICompany[]) {
  const store = getStore();
  store.companies = companies;
  storeObject('store', store);
}

export const getCompanies = () => {
  const store = getStore();
  return store ? store.companies : [] as ICompany[];
}

export const setPrivacyStatement = (privacyStatement: IPrivacyStatement[]) => {
  const store = getStore();
  store.privacyStatement = privacyStatement;
  storeObject('store', store);
}

export const getPrivacyStatement = () => {
  const store = getStore();
  return store ? store.privacyStatement : [] as IPrivacyStatement[];
}

export const setCategories = (categories: IPomReportCategoryData[]) => {
  const store = getStore();
  store.categories = categories;
  storeObject('store', store);
}

export const getCategories = () => {
  const store = getStore();
  return store ? store.categories : [] as IPomReportCategoryData[];
}

export const setSettings = (settings: ISettings) => {
  const store = getStore();
  store.settings = settings;
  storeObject('store', store);
}

export const getSettings = () => {
  const store = getStore();
  return store ? store.settings : {} as ISettings;
}

export const setMessages = (messages: IMailTemplateDetails) => {
  const store = getStore();
  store.messages = messages;
  storeObject('store', store);
}

export const getMessages = () => {
  const store = getStore();
  return store ? store.messages : {} as IMailTemplateDetails;
}

export const setInfotexts = (infotexts: IInfoTextDetails) => {
  const store = getStore();
  store.infotexts = infotexts;
  storeObject('store', store);
}

export const getInfotexts = () => {
  const store = getStore();
  return store ? store.infotexts : {} as IInfoTextDetails;
}